/*
 * The copy button of code blocks (.codeBlock > button), shared by the docs
 * pages and the site's other public pages (code_blocks_public, 22 October
 * 2026). The button names its code with data-clipboard-target (a selector) or
 * carries the text in data-clipboard-text.
 */

export function copyText(text) {
    const fallback = () => {
        const input = document.createElement('textarea');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.top = '-1000px';
        document.body.appendChild(input);
        input.select();
        let ok = false;
        try {
            ok = document.execCommand('copy');
        } catch (e) {
            ok = false;
        }
        document.body.removeChild(input);
        return ok;
    };

    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).then(() => true, fallback);
    }
    return Promise.resolve(fallback());
}

/** Copies a code block's code when its button (matching `selector`) is clicked. */
export function initCopyCode(selector) {
    document.addEventListener('click', (event) => {
        const button = event.target.closest ? event.target.closest(selector) : null;
        if (!button) return;
        const target = button.getAttribute('data-clipboard-target');
        let text = button.getAttribute('data-clipboard-text');
        if (text === null && target) {
            let el = null;
            try {
                el = document.querySelector(target);
            } catch (e) {
                el = target[0] === '#' ? document.getElementById(target.slice(1)) : null;
            }
            if (!el) return;
            text = 'value' in el && typeof el.value === 'string' ? el.value : el.textContent;
        }
        if (text === null) return;

        copyText(text).then((ok) => {
            if (!ok) return;
            // The stylesheet spells it this way
            button.classList.add('sucess');
            setTimeout(() => button.classList.remove('sucess'), 1000);
        });
    });
}
